import axios from "../config/axios";

interface TemplateSection {
  id: number;
  title: string;
  instructions: string;
  order: number;
  created_at: string;
  updated_at: string | null;
}

export interface Template {
  id: number;
  name: string;
  description: string;
  is_default: boolean;
  created_at: string;
  updated_at: string | null;
  sections: TemplateSection[];
}

export interface CreateTemplateSection {
  title: string;
  instructions: string;
}

export interface CreateTemplateRequest {
  name: string;
  description: string;
  isDefault: boolean;
  sections: CreateTemplateSection[];
}

export interface UpdateTemplateRequest {
  name: string;
  description: string;
  is_default: boolean;
  sections: Array<{
    id?: number;
    title: string;
    instructions: string;
    order: number;
  }>;
}

export const templateService = {
  async getTemplates(): Promise<Template[]> {
    const response = await axios.get("/api/scribing/templates/");
    return response.data;
  },

  async getTemplate(id: number): Promise<Template> {
    const response = await axios.get(`/api/scribing/templates/${id}`);
    return response.data;
  },

  async deleteTemplate(id: number): Promise<void> {
    await axios.delete(`/api/scribing/templates/${id}`);
  },

  async createTemplate(template: CreateTemplateRequest): Promise<Template> {
    const response = await axios.post("/api/scribing/templates/create", template);
    return response.data;
  },

  async updateTemplate(
    id: number,
    template: UpdateTemplateRequest
  ): Promise<Template> {
    const response = await axios.put(`/api/scribing/templates/${id}`, template);
    return response.data;
  },
};
